import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'

import { extensionNotifyUserSessionChange } from '@lib/utils/extension'

import { Fireflies } from '@custom/components/fireflies/fireflies'
import { HeroBackgroundVideo } from '@custom/components/hero-background-video/hero-background-video'

import Agents from './agents/agents'
import { ContextProvider } from './contexts/context-provider'
import Header from './header/header'
import { useAddAgents } from './hooks/use-add-agent'
import { useAgents } from './hooks/use-agents'
import { useStepImpressionTracking } from './hooks/use-step-impression-tracking'
import { useStepWithScrollDetection } from './hooks/use-step-with-scroll-detection'
import { GoTime } from './main-content/go-time/go-time'
import MainContent from './main-content/main-content'
import ScrollIndicator from './scroll-indicator/scroll-indicator'
import { type Agent, ProofreaderAgent } from './utils/cards'
import { Step } from './utils/steps'

import style from './superhuman-go-intro.module.scss'

const SuperhumanGoIntroPageContent = () => {
  useStepImpressionTracking()

  const mainPageRef = useRef<HTMLDivElement>(null)
  const { step } = useStepWithScrollDetection(mainPageRef)

  const [agents, setAgents] = useState<Agent[]>([ProofreaderAgent])
  useAgents(setAgents, agents.length)
  useAddAgents(setAgents, agents)

  const showScrollIndicator = step === Step.FullBench || step === Step.UseAgentSkillAnyWhere

  useEffect(() => {
    // TODO: Add condition to only sync session based on ?source=enable_go query param that will be added soon
    extensionNotifyUserSessionChange()
  }, [])

  return (
    <div className={style.page} data-color-scheme="dark">
      <HeroBackgroundVideo
        className={clsx(step === Step.GoTime && style.onlyLeftMask, style.hasOverlay)}
      />
      <Header />
      <Agents agents={agents} />

      <main className={style.mainPage} ref={mainPageRef}>
        <div className={style.main}>
          <MainContent agents={agents} />
          <GoTime />
        </div>
      </main>
      {showScrollIndicator && <ScrollIndicator />}
      <Fireflies className={style.fireflies} />
    </div>
  )
}

const SuperhumanGoIntroPage = () => {
  return (
    <ContextProvider>
      <SuperhumanGoIntroPageContent />
    </ContextProvider>
  )
}

export default SuperhumanGoIntroPage
